import { Component,  Input } from '@angular/core';
import { publicHelpers } from './../../helpers/public-helpers';
import { Attendee } from 'globals/store/attendees.data';
import { PhotoComponent } from 'src/app/components/photo';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { TextNoTextComponent } from 'src/app/components/misc/text-no-text.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'attendee-profile',
    template: `
<div class="attendee-box">
  <div class="attendee-pics">
    <photo [data]="{photoURL: attendee.photoUrl, title: attendee.name }" [size]="120"></photo>
  </div>
  <div class="attendee-info">
    <div class="bold-text">{{ attendee.name }}</div>
    <text-no-text [text]="attendee.line1 || ''" [placeholder]="'Line 1'"></text-no-text>
    <text-no-text [text]="attendee.line2 || ''" [placeholder]="'Line 2'"></text-no-text>
    <div class="spacer"></div>
    <a *ngIf="attendee.email" class="secondary_link attendee-email" href="mailto:{{attendee.email}}">{{attendee.email}}</a>

    <text-no-text [text]="attendee.phone || ''"></text-no-text>
    <div class="spacer"></div>
    <social-links *ngIf="attendee?.social?.length" [socialLinks]="attendee.social || []"></social-links>
  </div>
</div>
  `,
    styleUrls: ['../../components/performers/performerProfile.scss', './../../components/performers/managePerformer.dialog.scss'],
    styles: [`
  resource-contact-card { margin-top: 5px; }  
`],
    standalone: true,
    imports: [PhotoComponent, CommonModule, SocialLinksComponent, TextNoTextComponent]
})
export class AttendeeProfileComponent {
  publicHelpers = publicHelpers
  @Input() attendee: Attendee

}